import { User } from "react-feather";

export type SidebarItemsType = {
  Link: string;
  Name: string;
  Icon: React.FC<any>;
  children?: SidebarItemsType[];
  badge?: string;
};

var elementsSectionForSupport = [
  {
    Link: "/",
    Icon: User,
    Name: "User Profile"
  }
] as SidebarItemsType[];

if (process.env.REACT_APP_ENV_NAME === "int") {
}

const menuItems = [
  {
    title: "",
    role: "all",
    pages: elementsSectionForSupport
  }
];

export default menuItems;
